const initailState = {
    arr:[],
    nextKey:''
}
const SalesReferral=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_REFERRAL':
            return{ 
                arr: state.arr.concat(action.payload),
                nextKey:action.keynext
            }
        default:
            return state;
    }
}

export default SalesReferral